export class ButtonConfig {
  public title: string;
  public isMatRaisedButton: boolean;
  public isMatButton: boolean;
  constructor(
    public _title: string,
    public _isMatRaisedButton: boolean,
    public _isMatButton: boolean,
    public onClick: () => void
  ) {
    this.title = _title;
    this.isMatRaisedButton = _isMatRaisedButton;
    this.isMatButton = _isMatButton;
  }
}
